<template>
	<div
		style="width: 95%"
		class="ml-5"
	>
		<loading-overlay
			:active="isLoaded"
			:can-cancel="true"
		/>
		<b-modal
			id="photoframe-modal"
			ref="photoframe-modal"
			hide-footer
		>
			<template #modal-title>
				Create New Photoframe
			</template>
			<div class="d-block text-center">
				<b-form-group
					class="form-group"
					label="Name: "
					label-for="block-form1-name"
				>
					<b-form-input
						v-model="addPhotoframeData.name"
						type="text"
					/>
				</b-form-group>
			</div>
			<b-button
				class="mt-3"
				block
				@click="addPhotoframe()"
			>
				Save
			</b-button>
		</b-modal>
		<base-block
			title="Existing Photoframe"
			header-bg
		>
			<div
				ref="photoframeTable"
			/>
		</base-block>
	</div>
</template>
